var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-snackbar',{class:_vm.color,attrs:{"timeout":_vm.timeout},model:{value:(_vm.display),callback:function ($$v) {_vm.display=$$v},expression:"display"}},[_vm._v("\n   "+_vm._s(_vm.message)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53ca1b5f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/Event.vue
// module id = MMvB
// module chunks = 1